import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uploadFile from '@/components/upload/uploadFile.vue';
import pictureLibrary from '@/views/custom-layout/components/pictureLibrary.vue';
import { getPictureByKey, getUnionModule } from '@/views/custom-layout/api';
export default {
  name: 'saas_module_plate',
  components: {
    uploadFile: uploadFile,
    pictureLibrary: pictureLibrary
  },
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    uploadInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      showPictureLibrary: false,
      pictureList: [],
      depot: {},
      linkUrl: {
        config: '/package/banner/upload/config',
        extensions: '/package/banner/upload/file-allow-extensions'
      },
      rules: {
        style: [{
          required: true,
          message: '请选择类型',
          trigger: 'change'
        }],
        title_bar_image: [{
          required: true,
          message: '图片不可为空'
        }],
        title: [{
          max: 20,
          message: '标题长度不得超过20个字',
          trigger: 'change'
        }],
        module_plate_id: [{
          required: true,
          message: '活动板块不可为空'
        }],
        activity_num: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!/^[0-9]*$/.test(value)) {
              callback('仅支持正整数');
            } else if (value > 99 || value < 1) {
              callback('仅支持1-99正整数');
            } else {
              callback();
            }
          },
          trigger: 'change'
        }]
        // show_style: [{ required: true, message: '楼层展示布局不可为空' }]
      },
      moduleList: [],
      typeList: [{
        name: '缩略图列表（有图片、活动简介、活动时间）',
        id: '1',
        imageurl: 'https://res.youlianfuwu.com/mini_program/shop/icon_saas_module_plate.jpg'
      }, {
        name: '简洁活动列表（仅展示活动或新闻标题）',
        id: '2',
        imageurl: 'https://res.youlianfuwu.com/mini_program/shop/topnews-eg.jpg'
      }],
      updateType: ''
    };
  },
  methods: {
    changeModule: function changeModule(val) {
      var data = this.moduleList.find(function (i) {
        return i.id === val;
      });
      if (data) {
        var module_id = data.module_id,
          module_type = data.module_type,
          open_module_type = data.open_module_type;
        this.value.config.module_id = module_id;
        this.value.config.module_type = module_type;
        this.value.config.open_module_type = open_module_type;
      }
    },
    getUnionModuleList: function getUnionModuleList() {
      var _this = this;
      // 获取SaaS板块下拉数据
      var _this$info = this.info,
        customer_id = _this$info.customer_id,
        module = _this$info.module;
      getUnionModule({
        customer_id: customer_id
      }, module).then(function (res) {
        _this.moduleList = res.data;
      });
    },
    handleDelUpload: function handleDelUpload(propName) {
      var _this2 = this;
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this2.value.config[propName] = '';
      });
    },
    // 获取对应组件图库信息
    getPicture: function getPicture() {
      var _this3 = this;
      getPictureByKey({
        key: this.value.key
      }, this.info.module).then(function (res) {
        var _res$data = res.data,
          _res$data$depot = _res$data.depot,
          depot = _res$data$depot === void 0 ? {} : _res$data$depot,
          _res$data$picture = _res$data.picture,
          picture = _res$data$picture === void 0 ? {} : _res$data$picture;
        _this3.pictureList = picture[1] || [];
        _this3.depot = depot; // 分类枚举
      });
    },
    onChangePic: function onChangePic(data) {
      var path = data.path;
      this.value.config[this.updateType] = path;
      this.showPictureLibrary = false;
    },
    selectPicture: function selectPicture(prop) {
      this.updateType = prop;
      this.showPictureLibrary = true;
    },
    onUpload: function onUpload(refName) {
      this.$refs[refName].uploadBanner();
    },
    emitUploadFile: function emitUploadFile(url, propName) {
      this.$set(this.value.config, propName, "".concat(this.$ossurl).concat(url));
    },
    deleteImg: function deleteImg() {
      var _this4 = this;
      if (!this.value.config.title_bar_image) {
        return;
      }
      this.$confirm('确定要删除吗', '提示', {
        confirmButtonText: '确定',
        dangerouslyUseHTMLString: true,
        type: 'warning'
      }).then(function () {
        _this4.value.config.title_bar_image = '';
      });
    }
  },
  created: function created() {
    var _this$value$config = this.value.config,
      _this$value$config$ma = _this$value$config.margin_top,
      margin_top = _this$value$config$ma === void 0 ? 15 : _this$value$config$ma,
      _this$value$config$z_ = _this$value$config.z_index,
      z_index = _this$value$config$z_ === void 0 ? 2 : _this$value$config$z_,
      _this$value$config$ti = _this$value$config.title_font_size,
      title_font_size = _this$value$config$ti === void 0 ? '28' : _this$value$config$ti,
      _this$value$config$ti2 = _this$value$config.title_font_color,
      title_font_color = _this$value$config$ti2 === void 0 ? '#000000' : _this$value$config$ti2,
      _this$value$config$ac = _this$value$config.activity_name_font_size,
      activity_name_font_size = _this$value$config$ac === void 0 ? '30' : _this$value$config$ac,
      _this$value$config$ac2 = _this$value$config.activity_name_font_color,
      activity_name_font_color = _this$value$config$ac2 === void 0 ? '#000000' : _this$value$config$ac2,
      _this$value$config$st = _this$value$config.style,
      style = _this$value$config$st === void 0 ? '1' : _this$value$config$st,
      _this$value$config$pr = _this$value$config.prefix_icon,
      prefix_icon = _this$value$config$pr === void 0 ? 'https://res.youlianfuwu.com/mini_program/shop/icon_headlines.png' : _this$value$config$pr;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({
      title_bar_image: '',
      title: '',
      module_id: '',
      module_type: '',
      open_module_type: '',
      module_plate_id: '',
      activity_num: '5',
      show_style: '1',
      margin_top: margin_top,
      //兼容新老组件 默认预置15px
      z_index: z_index,
      //兼容新老组件 默认预置2
      title_font_size: title_font_size,
      title_font_color: title_font_color,
      activity_name_font_size: activity_name_font_size,
      activity_name_font_color: activity_name_font_color,
      style: style,
      prefix_icon: prefix_icon
    }, this.value.config_default_value), this.value.config));
    this.getPicture();
    this.getUnionModuleList();
  }
};